export default {
  en: {
    'login.components.forgot-password-panel.title': 'Forgot Password',
    'login.components.forgot-password-panel.confirmation':
      "Check your email. We've sent you a link to reset your password.",
  },
};
